import React from 'react';
import { connect } from 'react-redux';
import * as globals from '../globals';

import store from '../store';
import {
  uidDuck,
  permissionsDuck,
  activePracticeDuck,
  userDataDuck,
} from '../ducks/root';

class AuthManager extends React.Component {
  componentDidMount() {
    this.unregisterAuthObserver = globals.auth.onAuthStateChanged(
      async user => {
        if (this.cancelPermsListener) this.cancelPermsListener();
        if (this.cancelUserListener) this.cancelUserListener();

        if (user === null) {
          store.dispatch(uidDuck.clear());
          console.log('no user found');
          return;
        }

        store.dispatch(uidDuck.set(user.uid));
        try {
          this.cancelUserListener = await globals.db
            .child(`users/${user.uid}`)
            .on('value', async userSnap => {
              if (!userSnap) return;
              const userData = userSnap.exists() ? userSnap.val : {};
              store.dispatch(userDataDuck.set(userData));
            });

          this.cancelPermsListener = await globals.db
            .child('permissions/' + user.uid)
            .on('value', async permsSnap => {
              if (
                !permsSnap ||
                !permsSnap.exists() ||
                permsSnap.val() === null
              ) {
                store.dispatch(permissionsDuck.clear());
                store.dispatch(activePracticeDuck.clear());
                return;
              }

              let perms = await permsSnap.val();
              store.dispatch(permissionsDuck.set(perms));

              if (!this.props.activePractice) {
                let firstPid = Object.keys(perms)[0];
                store.dispatch(activePracticeDuck.set(firstPid));
              } else {
                console.log('not overwriting active entity');
              }
            });
        } catch (err) {
          console.log(err);
          alert(err.message);
        }
      }
    );
  }

  componentWillUnmount() {
    this.unregisterAuthObserver();
    if (this.cancelUserListener) this.cancelUserListener();
    if (this.cancelPermsListener) this.cancelPermsListener();
  }
  render() {
    return null;
  }
}

const mstp = state => ({
  activePractice: state.activePractice,
});
export default connect(mstp)(AuthManager);
